import { FunnelType } from 'scenes/common/types';
import { route } from 'scenes/common/helpers/route';
import { History } from 'history';

export const redirectToOutagePage = (history: History): void => {
  history.push(route(FunnelType.Outage, ''));
};

export default redirectToOutagePage;
